module.exports = __webpack_public_path__ + "static/cosyelephantmain-b7098359d1d52395e38d49f891fb5e3e.png";